import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { Modal, ModalBody, ModalFooter } from 'reactstrap'
import { setAreYouSureModalData } from 'store/Recruitment/actions'

function AreYouSureModal({ customFn }) {
  const dispatch = useDispatch()

  const { showAreYouSureModal } = useSelector((store) => store.recruitment)

  return (
    <Modal
      isOpen={showAreYouSureModal.show}
      toggle={() => dispatch(setAreYouSureModalData({ show: false }))}
      size='md'
      centered
      scrollable
    >
      <ModalBody className='scrollbar justify-content-center text-center'>
        <FontAwesomeIcon
          icon={faCircleExclamation}
          size='4x'
          className='text-warning'
        />

        <h1 className='mt-4'>Are You Sure?</h1>

        {!showAreYouSureModal?.hideDefault ? (
          <p>This action can not be undone. Do you want to continue?</p>
        ) : null}

        <p>{showAreYouSureModal?.text}</p>
      </ModalBody>
      <ModalFooter>
        <div
          className='d-flex w-100 justify-content-center'
          style={{ gap: '1.5rem' }}
        >
          <button
            onClick={() => dispatch(setAreYouSureModalData({ show: false }))}
            className='btn btn-danger'
          >
            No
          </button>
          <button
            onClick={() => {
              if (showAreYouSureModal.customFn) {
                showAreYouSureModal.customFn()
              }
              dispatch(setAreYouSureModalData({ show: false }))
            }}
            className='btn btn-success'
          >
            Yes
          </button>
        </div>
      </ModalFooter>
    </Modal>
  )
}

export default AreYouSureModal
